import { render, staticRenderFns } from "./Invoer.vue?vue&type=template&id=972ae55a&scoped=true"
import script from "./Invoer.vue?vue&type=script&lang=js"
export * from "./Invoer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972ae55a",
  null
  
)

export default component.exports